import { Fragment, type ReactElement } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import { toJsxRuntime } from 'hast-util-to-jsx-runtime';
import type { Components } from 'hast-util-to-jsx-runtime';
import type { Nodes } from 'hast';

export interface HastToReactOptions {
  components?: Partial<Components>;
  space?: 'html' | 'svg';
}

/**
 * Single conversion point from HAST to React elements.
 *
 * Everything the viewer renders -- documents, Shiki output, KaTeX output and
 * Mermaid SVG -- funnels through here, which is what lets the app avoid
 * `dangerouslySetInnerHTML` entirely.
 */
export const hastToReact = (tree: Nodes, options: HastToReactOptions = {}): ReactElement =>
  toJsxRuntime(tree, {
    Fragment,
    jsx,
    jsxs,
    passNode: true,
    // Without this a single unparseable `style` value throws and takes out the
    // whole subtree. Mermaid emits such values for some diagram types.
    ignoreInvalidStyle: true,
    ...options,
  } as Parameters<typeof toJsxRuntime>[1]);
